// ============================================================
// Fee Receipts API
// ============================================================
// Endpoints for creating fee receipts (collecting fees) and viewing
// receipt history for the school or specific students.

import client from './axios';

export const feeReceiptsApi = {
  /**
   * Create a new fee receipt (Fee Collection)
   * @param {string} schoolId - School UUID
   * @param {object} payload - Payment details and items array
   */
  createReceipt: async (schoolId, payload) => {
    const response = await client.post(
      `/fee-receipts?school_id=${schoolId}`,
      payload
    );
    return response.data;
  },

  /**
   * Get paginated fee receipts for a school
   * @param {string} schoolId - School UUID
   * @param {number} skip - Offset
   * @param {number} limit - Max items
   */
  getReceipts: async (schoolId, skip = 0, limit = 100) => {
    const response = await client.get(
      `/fee-receipts?school_id=${schoolId}&skip=${skip}&limit=${limit}`
    );
    const data = response.data;
    return Array.isArray(data) ? data : data?.data || data?.items || [];
  },

  /**
   * Get single fee receipt by ID
   * @param {string} schoolId - School UUID
   * @param {string} receiptId - Receipt UUID
   */
  getReceiptById: async (schoolId, receiptId) => {
    const response = await client.get(
      `/fee-receipts/${receiptId}?school_id=${schoolId}`
    );
    return response.data;
  },

  /**
   * Get all fee receipts for a specific student
   * @param {string} schoolId - School UUID
   * @param {string} studentId - Student UUID
   */
  getStudentReceipts: async (schoolId, studentId) => {
    if (!studentId || !schoolId) return [];
    const response = await client.get(
      `/fee-receipts/students/${studentId}?school_id=${schoolId}`
    );
    const data = response.data;
    return Array.isArray(data) ? data : data?.data || data?.items || [];
  },

  /**
   * Cancel a fee receipt
   * @param {string} schoolId - School UUID
   * @param {string} receiptId - Receipt UUID
   */
  cancelReceipt: async (schoolId, receiptId) => {
    const response = await client.post(
      `/fee-receipts/${receiptId}/cancel?school_id=${schoolId}`
    );
    return response.data;
  },
};
